import { makeRequest } from "../http-common";

const UserDataService = {
  user_admin_codes() {
    return [
      { id: 0, label: "No" },
      { id: 1, label: "Yes" },
    ];
  },
  user_underwriter_codes() {
    return [
      { id: 0, label: "No" },
      { id: 1, label: "Yes" },
    ];
  },
  user_status_codes() {
    return [
        { id: 0, label: "Inactive" },
        { id: 1, label: "Active" },
      ];
  },

  async getById(id) {
    return makeRequest("get", `/user/${id}`);
  },

  async getProfileById(id) {
    return makeRequest("get", `/user/${id}/profile`);
  },

  async getActiveUsers() {
    return makeRequest("get", `/user/list/active`);
  },

  async getAllUsers() {
    return makeRequest("get", `/user/list`);
  },
  async getAdminUser(id) {
    return makeRequest("get", `/user/admin/show/${id}`);
  },
  create(data) {
    return makeRequest("post", "/user", data);
  },

  update(id, data) {
    return makeRequest("put", `/user/${id}`, data);
  },
};

export default UserDataService;
